export const HTTP_CODE = {
  NOT_FOUND: 404,
  TEMPORARILY_UNAVAILABLE: 480,
  NOT_EXIST: 481,
  NO_MORE_RESULT: 483,
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  ACCEPTED: 202,
  BUCKET_MAPPING_NOT_AVAILABLE: 482,
  ROOMS_DROP_ERROR: 420,
};

export const SNAP_HTTP_CODE = {
  NOT_FOUND: 404,
  BAD_REQUEST: 400, // Not met the required criteria
  HOTEL_NOT_FOUND_EXCEPTION: 480, // No hotel found for search criteria or invalid criteria
  FLIGHTS_NOT_FOUND_EXCEPTION: 481, // When there is no flight inventories in listing
  CURRENCY_CONVERSION_EXCEPTIION: 482, // While fetching curries the requested currency not available
  HOTEL_LEAD_PRICE_NOT_FOUND_EXCEPTION: 483, // Lead prices not available for Snap hotel recommendations
  HOTEL_ROOM_DEAILS_NOT_FOUND_EXCEPTION: 490, // Not able to get room inventories in Details
  HOTEL_STATIC_DATA_EXCEPTION: 491, // Not able to get the static content this error will come
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  ACCEPTED: 202,
};

export const SNAP_CHECKOUT_ERRORS = {
  //Need to revamp checkout errors...
};

export const CHECKOUT_STATUS_CODE = {
  PRICE_CHANGED: 409,
  DIFFERENT_NAME: 485, // unlimited pass promo code different name
  BOOKED_WITH_SAME_DATE: 486, // unlimited pass booking same date
  HOTEL_SOLD_OUT: 410,
};

export const FLIGHT_STATUS_CODE = {
  CLASS_SERVICE_SOLD_OUT: 418,
  DEALS_PROMO_ERROR: 483,
  NO_FARE_AVAILABLE: 484,
  PROMOTION_DOES_NOT_EXIST: 419,
  INVALID_DATA: 417,
  SSR_INFT_NOT_AVAILABLE: 463,
};
